<div
  data-e2e="bulk-paste-toggle"
  class="custom-control-group custom-switch d-flex"
>
  <input
    data-e2e="check-box"
    type="checkbox"
    class="custom-control-input"
    [class.bi-state]="biState"
    [id]="inputId"
    [formControl]="control"
  />
  <label class="custom-control-label" [for]="inputId">
    <ng-content></ng-content>
  </label>
</div>
